import Icon from 'components/common/Icon';
import { Sidebar, SidebarPageLink } from 'components/layout/SurveyWithSidebar';

import {
  useHasRole,
  useHasOrganization,
  ORG_ID_GP,
  ORG_ID_INSOMNIA,
  ORG_ID_REDBULL,
} from 'hooks/users';

const SidebarNavAnalytics = ({ surveyId }: { surveyId: number }) => {
  const isAdmin = useHasRole('admin');
  const isGPUser = useHasOrganization(ORG_ID_GP);
  const isInsomniaUser = useHasOrganization(ORG_ID_INSOMNIA);
  const isRedbullUser = useHasOrganization(ORG_ID_REDBULL);

  return (
    <Sidebar
      links={
        <>
          <SidebarPageLink
            icon={<Icon id="bar-chart-10" />}
            to={`/surveys/${surveyId}/analyze`}
          >
            Analytics
          </SidebarPageLink>
          <SidebarPageLink
            icon={<Icon id="file-07" />}
            to={`/surveys/${surveyId}/analyze/summary-reports`}
          >
            Summary Reports
          </SidebarPageLink>
          <SidebarPageLink
            end={false}
            icon={<Icon id="table" />}
            to={`/surveys/${surveyId}/analyze/export`}
          >
            Build Export
          </SidebarPageLink>
          {(isAdmin || isGPUser || isInsomniaUser || isRedbullUser) && (
            <SidebarPageLink
              icon={<Icon id="user-check-01" />}
              to={`/surveys/${surveyId}/analyze/manage-responses`}
            >
              Manage Responses
            </SidebarPageLink>
          )}
          <SidebarPageLink
            icon={<Icon id="download-cloud-01" />}
            to={`/surveys/${surveyId}/analyze/exports`}
          >
            Exports
          </SidebarPageLink>
        </>
      }
    />
  );
};

export default SidebarNavAnalytics;
